// extracted by mini-css-extract-plugin
export default {"button":"StyleSecondarySmallTrueD_button__DlzO7","stylesecondarySmalltrueD":"StyleSecondarySmallTrueD_stylesecondarySmalltrueD__ETeFS"};